import React from "react";
import _ from "lodash";
import { connect } from "formik";
import { CheckboxSelectListInput } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelCheckboxSelectListInput = ({ label, fieldName, options, placeholder, formik, isDisabled, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      <CheckboxSelectListInput
        label={placeholder}
        fieldName={fieldName}
        options={options}
        isDisabled={isDisabled}
        {...otherProps}
      />
    </LateralField>
  );
};
export default connect(SideLabelCheckboxSelectListInput);
